import { useIsMobile } from '@/hooks/useSizeBreakpoints'
import { Skeleton } from '@mui/material'
import { STATISTICS_CONSTANTS } from '../lib/constants'

export function ChartSkeleton() {
  const isMobile = useIsMobile()
  return (
    <Skeleton 
      variant="rectangular" 
      height={isMobile ? STATISTICS_CONSTANTS.MOBILE_SKELETON_HEIGHT : STATISTICS_CONSTANTS.SKELETON_HEIGHT} 
      sx={{ borderRadius: 1 }} 
    />
  )
}
